import { KCFColor } from 'styles/themes/KCFColor';
import { KCFStyle } from 'styles/themes/KCFStyle';
import type { KCFTheme } from 'styles/themes/KCFTheme';

export const LightTheme: KCFTheme = {
    bodyBackgroundColor: KCFColor.lightGrey1,
    backgroundColor: KCFColor.white,
    backgroundColorActive: KCFColor.lightGrey1,
    shadeBackgroundColor: KCFColor.offWhite1,
    secondaryBackgroundColor: KCFColor.lightGrey2,
    activeBackgroundColor1: KCFColor.blue1,
    activeBackgroundColor2: KCFColor.blue2,

    navColor: KCFColor.white,
    borderColor: KCFColor.lightGrey2,
    navBorderColor: KCFColor.lightGrey3,
    primaryBoxShadow: KCFStyle.primaryBoxShadow,
    menuBoxShadow: KCFStyle.menuBoxShadow,
    modalBoxShadow: KCFStyle.modalBoxShadow,
    primaryText: KCFColor.primaryText,
    secondaryText: KCFColor.secondaryText,
    secondaryButton: KCFColor.white,
    secondaryButtonHover: KCFColor.lightGrey1,
    // TODO: This color was not picked by a designer.
    disabledText: KCFColor.mediumGrey5,
    cancelButton: KCFColor.lightGrey2,
    cancelButtonHover: KCFColor.lightGrey3,
    deleteButton: KCFColor.red1,
    deleteButtonHover: KCFColor.strongRedDark,
    warningButton: KCFColor.orange2,
    warningButtonHover: KCFColor.orange3,
    iconButtonBackgroundHover: KCFColor.lightGrey3,
    link: KCFColor.linkDefault,
    linkShifted: KCFColor.linkShiftedDefault,
    title: KCFColor.blueGrey,

    // Form elements
    inputBorder: KCFColor.lightGrey3,
    inputBorderFocused: KCFColor.blue5,
    inputBorderInvalid: KCFColor.primaryRed,
    inputBorderValid: KCFColor.primaryGreen,
    filterRadioButton: KCFColor.mediumGrey5,

    infoBox: KCFColor.lightGrey3,

    // asset cards
    assetCardReportBackgroundColor: KCFColor.mediumGrey6,

    chartBackgroundColor: KCFColor.white,
    chartPlotGridBackgroundColor: KCFColor.lightGrey1,

    workbenchHeader: KCFColor.mediumGrey6,
    workbenchHeaderButtonHover: KCFColor.mediumGrey7,

    // timeseries
    timeseriesBackgroundColor: KCFColor.white,
    timeseriesAxisColor: KCFColor.timeseriesAxis,
    timeseriesGridColor: KCFColor.timeseriesGrid,
    timeseriesDrawerUnselectedColor: KCFColor.lightGrey2,
    timeseriesErrorIconColor: KCFColor.orange4,
    timeseriesErrorBackgroundColor: KCFColor.orange5,

    // treeview
    treeviewIconColor: KCFColor.mediumGrey4,
    activityLineColor: KCFColor.mediumGrey4,
    markerTableSelectedColor: KCFColor.markerTableSelectedBackgroundColor,

    // icons
    iconColor: KCFColor.mediumGrey4,

    // notifications
    notificationsCog: KCFColor.mediumGrey4,
    notificationsHeaderText: KCFColor.blue7,

    // Tabs
    tabSelected: KCFColor.lightGrey2,
    tabsBottomBorder: KCFColor.whiteGrey,

    successToastColor: KCFColor.successToast,
    errorToastColor: KCFColor.lightRed,

    // popups
    popupBackgroundColor: KCFColor.mediumGrey6,
    popupText: KCFColor.white,

    issueQueueButtonBackgroundColor: KCFColor.lightGrey4,

    kcfOnlyLozengeBackground: KCFColor.darkGrey8,
    kcfOnlyLozengeText: KCFColor.white,

    // Hardware Status Action Button
    hardwareStatusActionButtonBackground: KCFColor.hardwareStatusActionButtonBackground,
    hardwareStatusActionButtonBackgroundHover:
        KCFColor.hardwareStatusActionButtonBackgroundHover,

    // Sentry validation indicator
    sentryValidatedIconColor: KCFColor.green3,

    // Alarm severity
    criticalSeverity: KCFColor.criticalSeverity,
    alarmSeverity: KCFColor.alarmSeverity,
    warningSeverity: KCFColor.lowSeverity,

    dashboardAccentPrimary: KCFColor.blue9,
    dashboardAxisText: KCFColor.dashboardAxisTextDarker,
};
